import React from 'react';
//import { withRouter } from 'react-router';
import { config } from "./../../Config";
import { Image } from 'semantic-ui-react';
import { Trads } from './../../components/TradsErrorPages/TradsErrorPages';
import './../Error404Page/Error404Page.css';
import './ErrorEstablishmentNotFound.css';

const ErrorEstablishmentNotFound = (props) => {

  let lang = typeof props.match.params.lang !== "undefined" ? props.match.params.lang : "FR";
  return (
    <div id="establishmentNotfound">
      <section id="notfoundMessage">
        <h2>{Trads.establishmentNotFound[lang]}</h2>
        <p>{Trads.establishmentDoesNotExist[lang]}</p>
        {/* <Button icon labelPosition="left" onClick={this.handleClickBackToHome}>
          <Icon name="arrow left" />
          Back to homepage
        </Button> */}
        <Image src={config.url.LOGO_MB} size="medium" className="mb-5" />
      </section>
      <div id="background-svg-error-page"/>
    </div>
  )
}

export default ErrorEstablishmentNotFound;